export default "__VITE_ASSET__BVUSUXFO__"